$(document).ready(function() {
    $('body :not(script)').contents().filter(function() {
      return this.nodeType === 3;
    }).each(function() {
      // Replace the symbols with a string containing <sup> tags
      var replacedText = this.nodeValue.replace(/[™®©]/g, '<sup>$&</sup>');
      // Parse the HTML so it is inserted as HTML, not as plain text
      $(this).replaceWith($.parseHTML(replacedText));
    });
  
    // Redirect /collections and /collections/all to wood-pellet-1
    if (['/collections', '/collections/all', '/collections/'].includes(window.location.pathname)) {
        window.location.href = '/collections/wood-pellet';
    }
  
    // Original array of paths
    const categoryPaths = [
        '/pages/recipes',
        '/pages/beef',
        '/pages/poultry',
        '/pages/pork',
        '/pages/vegetables',
        '/pages/seafood',
        '/pages/wild-game',
        '/pages/grill',
        '/pages/griddle',
        '/pages/smoke',
        '/pages/bbq',
        '/pages/bake',
        '/pages/braise',
        '/pages/roast',
        '/pages/regional-bbq',
        '/pages/appetizers',
        '/pages/breakfast',
        '/pages/lunch',
        '/pages/dinner',
        '/pages/sides',
        '/pages/extras',
        '/pages/quick-and-easy',
        '/pages/desserts',
        '/pages/leftover-ideas',
        '/pages/kid-friendly',
        '/pages/christmas',
        '/pages/thanksgiving',
        '/pages/date-night',
        '/pages/backyard-bbqs',
        '/pages/tailgating',
        '/pages/july-4th',
        '/pages/easter',
        '/pages/cinco-de-mayo',
        '/pages/st-patricks-day',
        '/pages/mothers-day',
        '/pages/fathers-day',
        '/pages/national-hot-dog-day',
        '/pages/national-wing-day'
    ];
  
    // Extract categories from paths
    const categories = categoryPaths.map(path => path.split('/').pop());
  
    // Create a category map
    const categoryMap = categories.reduce((acc, category) => {
        acc[category] = `/pages/${category}`;
        return acc;
    }, {});
  
    // Capture referrer
    const referrer = document.referrer;
    const refCategory = categoryPaths.find(path => referrer.includes(path));
  
    // Extract the category name from the referrer and store it in session storage
    if (refCategory) {
        const categoryName = refCategory.split('/').pop();
        console.log('User came from category:', categoryName);
        sessionStorage.setItem('lastRecipeCategory', categoryName);
    }

    // View Recipe Button Centering - Works on Mobile and Desktop
    let processedButtons = new Set(); // Track processed buttons to prevent duplicates
    let lastScreenWidth = window.innerWidth; // Track screen width changes
    
    function centerMobileButtons() {
        // Clear processed buttons if screen width changed
        if (window.innerWidth !== lastScreenWidth) {
            processedButtons.clear();
            lastScreenWidth = window.innerWidth;
        }
        
        // Find only promo blocks within the specific recipe section (not mosaic)
        // Look for promo-grid--height-small that contains recipe-related content
        const allSections = document.querySelectorAll('.promo-grid--height-small');
        let targetSection = null;
        
        // Find the section that contains recipe blocks (not mosaic)
        for (let section of allSections) {
            const promoBlocks = section.querySelectorAll('.promo-grid--inner .promo-block');
            if (promoBlocks.length > 0) {
                const firstBlock = promoBlocks[0];
                // Check if this is a recipe section (not mosaic)
                if (!firstBlock.classList.contains('promo-mosaic--maintain-aspect-ratio')) {
                    // Check if it contains recipe-related content
                    const button = firstBlock.querySelector('span.button-outline.promo-block--button.pxu-lia-element');
                    if (button && button.textContent.includes('Recipe')) {
                        targetSection = section;
                        break;
                    }
                }
            }
        }
        
        if (!targetSection) {
            return;
        }
        
        const promoBlocks = targetSection.querySelectorAll('.promo-grid--inner .promo-block');
        
        promoBlocks.forEach((block, blockIndex) => {
            // Find the content wrapper within each block
            const contentWrapper = block.querySelector('.promo-block--content-wrapper');
            if (!contentWrapper) {
                return;
            }
            
            // Find the button first to create unique identifier
            const button = contentWrapper.querySelector('span.button-outline.promo-block--button.pxu-lia-element');
            if (!button) {
                return;
            }
            
            // Create unique identifier for this button
            const buttonId = button.textContent.trim() + '_' + blockIndex;
            if (processedButtons.has(buttonId)) {
                return;
            }
            
            // Double-check that this button is actually within our target section
            if (!targetSection.contains(button)) {
                return;
            }
            
            // Apply flexbox to the content wrapper
            contentWrapper.style.setProperty('display', 'flex', 'important');
            contentWrapper.style.setProperty('flex-direction', 'column', 'important');
            contentWrapper.style.setProperty('justify-content', 'space-between', 'important');
            contentWrapper.style.setProperty('height', '100%', 'important');
            contentWrapper.style.setProperty('min-height', '300px', 'important'); // Ensure minimum height
            contentWrapper.style.setProperty('flex-grow', '1', 'important'); // Take up available space
            
            // Also ensure the parent content has proper height
            const content = block.querySelector('.promo-block--content');
            if (content) {
                content.style.setProperty('height', '100%', 'important');
                content.style.setProperty('display', 'flex', 'important');
                content.style.setProperty('flex-direction', 'column', 'important');
                content.style.setProperty('min-height', '300px', 'important'); // Ensure minimum height
            }
            
            // Apply centering styles to the button
            button.style.setProperty('text-align', 'center', 'important');
            button.style.setProperty('position', 'relative', 'important');
            button.style.setProperty('bottom', '0', 'important');
            
            // Full width button at bottom for all screen sizes
            button.style.setProperty('margin-top', 'auto', 'important'); // This pushes to bottom
            button.style.setProperty('width', '100%', 'important');
            button.style.setProperty('display', 'block', 'important');
            
            // Mark this button as processed
            processedButtons.add(buttonId);
        });
        
        // Now apply 200px width to all OTHER buttons on the page (not recipe buttons) - MOBILE ONLY
        if (window.innerWidth <= 719) {
            const allOtherButtons = document.querySelectorAll('span.button-outline.promo-block--button.pxu-lia-element');
            allOtherButtons.forEach((button, index) => {
                // Skip if this button is within our target recipe section
                if (targetSection.contains(button)) {
                    return;
                }
                
                // Create unique identifier for this button
                const buttonId = button.textContent.trim() + '_other_' + index;
                if (processedButtons.has(buttonId)) {
                    return;
                }
                
                // Apply 200px width to other buttons on mobile only
                button.style.setProperty('width', '200px', 'important');
                button.style.setProperty('display', 'inline-block', 'important');
                button.style.setProperty('text-align', 'center', 'important');
                
                // Mark this button as processed
                processedButtons.add(buttonId);
            });
        } else {
            // On desktop, reset other buttons to their default styling
            const allOtherButtons = document.querySelectorAll('span.button-outline.promo-block--button.pxu-lia-element');
            allOtherButtons.forEach((button, index) => {
                // Skip if this button is within our target recipe section
                if (targetSection.contains(button)) {
                    return;
                }
                
                // Create unique identifier for this button
                const buttonId = button.textContent.trim() + '_other_' + index;
                if (processedButtons.has(buttonId)) {
                    return;
                }
                
                // Reset to default styling on desktop - remove all custom styles
                button.style.removeProperty('width');
                button.style.removeProperty('display');
                button.style.removeProperty('text-align');
                
                // Mark this button as processed
                processedButtons.add(buttonId);
            });
        }
    }

    // Apply on load and resize (throttled for better mobile Safari performance)
    centerMobileButtons();
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(centerMobileButtons, 100);
    });

    // Run once more after a short delay to catch any late-loading content
    setTimeout(centerMobileButtons, 1000);
    
    // Also apply when new content is loaded (for dynamic content)
    const observer = new MutationObserver(function(mutations) {
        let shouldProcess = false;
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Check if any new promo blocks were added
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) { // Element node
                        if (node.classList && node.classList.contains('promo-block')) {
                            shouldProcess = true;
                        } else if (node.querySelector && node.querySelector('.promo-block')) {
                            shouldProcess = true;
                        }
                    }
                });
            }
        });
        
        if (shouldProcess) {
            setTimeout(centerMobileButtons, 100);
        }
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
  });
  